module.exports = __webpack_public_path__ + "partylineManage/img/guideImg.1890939c.png";